import React from "react";
import Chip from "@material-ui/core/Chip";
import { BATCH_STATUS } from "../../batches/components/FilteringBatchesDialog";
import { analyseTheme } from "../../analyse/analyseTheme";
import t from "../../../locales/t";

const StatusChip = ({ state }: { state: string }) => {
  //@ts-ignore
  if (!BATCH_STATUS[state]) return null;
  //@ts-ignore
  const { label, color, icon: Icon } = BATCH_STATUS[state];

  return (
    <Chip
      icon={
        <Icon style={{ color, marginLeft: 4, marginRight: -8, fontSize: 16 }} />
      }
      label={t(label)}
      variant="outlined"
      style={{
        color,
        borderColor: color,
        height: 24,
        fontSize: "0.75rem",
        borderRadius: analyseTheme.radiusXs,
      }}
    />
  );
};

export default StatusChip;
